// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-7b1c35c6] .el-dialog__header{background-color:#d7d7d7}[data-v-7b1c35c6] .el-dialog__footer{text-align:center}[data-v-7b1c35c6] .el-table__header .gutter{background-color:#d7d7d7}", ""]);
// Exports
module.exports = exports;
